<template>
  <transition name="scale">
    <ul class="mode-picker"
         :style="styles"
         v-show="display"
         ref="modePicker"
         v-on-clickaway="onClickOutside">
      <li class="close list-item">
        <div class="close-wrapper"
             @click="$emit('close')">
          <span class="close-text">
            {{ $t("close") }}
          </span>
          <icon-cross-bold class="close-icon"
                           width="7"
                           height="7"/>
        </div>
      </li>
      <li class="list-item"
          v-for="mode in modes"
          :key="mode.type">
        <base-radio class="mode"
                    value=""
                    :true-value="mode.type"
                    label-left
                    @change="onModeSelect(mode.type)">
          <div class="mode-label">
            <div class="circle"
                 :class="mode.iconClass"></div>
            {{ mode.title }}
          </div>
        </base-radio>
      </li>
    </ul>
  </transition>
</template>

<script>
  import { mixin as clickaway } from 'vue-clickaway'
  import i18n from '@/services/i18n'

  const modes = [
    {
      type: 'Pause Device',
      title: i18n.t("deviceAvailability.devicePaused"),
      iconClass: 'circle-device-paused'
    },
    {
      type: 'No Internet',
      title: i18n.t("deviceAvailability.noInternet"),
      iconClass: 'circle-no-internet'
    }
  ]

  export default {
    props: {
      childId: {
        required: true
      }
    },

    mixins: [ clickaway ],

    data() {
      return {
        display: false,
        y: 0,
        maxY: null,
        modes
      }
    },

    methods: {
      show(y, maxY) {
        this.y = y
        this.maxY = maxY
        this.display = true
      },

      hide() {
        this.y = null
        this.maxY = null
        this.display = false
      },

      onClickOutside(event) {
        this.$emit('clickOutside', event)
      },

      onModeSelect(modeType) {
        let child = this.getChildById(this.childId)
        let mode = child.modes.find(mode => mode.name === modeType)

        this.$emit('select', {
          mode_id: mode.id,
          mode_name: mode.name
        })
      }
    },

    computed: {
      styles() {
        if (this.isModePickerOnTheBottomEdge) {
          return {
            bottom: this.maxY - this.y + 'px'
          }
        }

        return {
          top: this.y + 'px'
        }
      },

      isModePickerOnTheBottomEdge() {
        return this.display && this.y + this.$refs.modePicker.offsetHeight > this.maxY
      },

      ...mapGetters('children', {
        getChildById: 'getById'
      })
    }
  }
</script>

<style lang="scss" scoped>
  .mode-picker {
    position: absolute;
    left: 0;
    z-index: 4;

    width: 200px;

    list-style-type: none;
    margin: 0;
    padding: 0;

    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.1);

    .list-item {
      &:not(:last-child) {
        border-bottom: 1px solid #f2f2f2;
      }
    }

    .mode,
    .close {
      padding: 10px;
    }

    .mode {
      width: 100%;

      .mode-label {
        display: flex;
        align-items: center;
      }

      .circle {
        width: 12px;
        height: 12px;
        margin-right: 8px;
        border-radius: 50%;
      }

      .circle-device-paused {
        background-color: #ec971d;
      }

      .circle-no-internet {
        background-color: map.get($colors, primary);
      }
    }

    .close {
      display: flex;
      justify-content: flex-end;
    }

    .close-wrapper {
      display: flex;
      align-items: center;
      color: #999;
      cursor: pointer;
      user-select: none;
      transition: all .1s ease-out;

      &:hover {
        color: color.adjust(#999, $lightness: -10%);
      }
    }

    .close-text {
      margin-right: 4px;
      font-size: 10px;
      font-weight: bold;
      text-transform: uppercase;
    }
  }
</style>
